<main>
  <div class="row">
    <div class="col-sm-12">
      <h2 class="text-primary mb-0">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Title' | translate}}</h2>
    </div>
  </div>

  <div class="col-sm-12 text-end">

  </div>


  <!--New table entry inputs-->
  <div *ngIf="expandNewBeneficiary" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewBeneficiary=!expandNewBeneficiary">
      <span aria-hidden="true" class="p-1 icon-close text-primary"></span>
    </button>
    <beneficiary-list-table-edit
                                 [dropdowns]="parentWorkflow.workflowDropdowns"
                                 [itemList]="cardData.beneficiaryList"
                                 (listChanged)="onBeneficiaryChanged($event)"
                                 [isServiceOrFunerary]="isServiceOrFunerary"></beneficiary-list-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        @if (hasLegalRepresentation){
        <th scope="col" class="icon"></th>
        }
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.Name' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.BenefitType' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.DeceasedRelationship' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasLegalRepresentation' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.LegalRepresentationName' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.RepresentationType' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.beneficiaryList; let i = index">
        <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          @if (hasLegalRepresentation){
          <td class="icon"
              [tooltip]="getStateText(tableItem.stateRL?.toString())"
              [style.color]="getStateColor(tableItem.stateRL?.toString())">
            <i style="font-size:20px" class="icon-user"></i>
          </td>
          }
          <td>{{tableItem.beneficiaryName}}</td>
          <td>{{benefitLabelAppearingFunction(tableItem.survivalPensionBenefit, tableItem.reimbursementFuneralBenefit, tableItem.funeralAllowanceBenefit)}}</td>
          <td>{{tableItem.deceasedRelationship | dropdowns:'DropdownDeceasedRelationship':dropdowns}}</td>
          <td>{{legalRepresentationLabelAppearingFunction(tableItem.hasLegalRepresentation)}}</td>
          <td>{{legalRepresentationNameLabelAppearingFunction(tableItem.hasLegalRepresentation, tableItem.legalRepresentationName)}}</td>
          <td>{{tableItem.representationType | dropdowns:'DropdownRepresentationType':dropdowns}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-edit'"></span>
            </button>
            <!--<button type="button" class="btn-icon" aria-label="Apagar" *ngIf="removeTrashButton(tableItem.beneficiaryID)">
      <span class="icon-trash p-1" (click)="removeFromList(cardData.beneficiaryList, tableItem ,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
    </button>-->
            <button type="button" class="btn-icon" aria-label="Erros" *ngIf="!isBeneficiaryValid(tableItem) && !isStateRLIndeferido(tableItem)" tabindex="-1">
              <span class="icon-info p-1" placement="bottom" [tooltip]="tipContent"></span>
            </button>
            <ng-template #tipContent>
              <div class="row tooltipCustom">
                <div class="col-12">
                  <span class="tooltipTitle">{{'WorkflowCreatePM.PreStage.CardHabilitandos.Tooltips.IsHabilitandoNotComplete' | translate}}</span>
                </div>
                <div class="col-12">
                  <span class="tooltipSubTitle">{{'WorkflowCreatePM.PreStage.CardHabilitandos.Tooltips.CamposEmFalta' | translate}}</span>
                </div>

              </div>
              <div class="row tooltipCustom" *ngFor="let erro of getErrorsOnHabilitando(tableItem); let idx = index">
                <div class="col-1"></div>
                <div class="col-11 tooltipItem" style="color: #e04f5f;" *ngIf="erro.key==null || erro.key==undefined">
                  {{erro.translation}}
                </div>
                <div class="col-11 tooltipItem" style="color: #e04f5f;" *ngIf="erro.key!=null && erro.key!=undefined">
                  {{erro.key | translate}}
                </div>
              </div>
            </ng-template>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="7" id="collapseBasic">
            <div class=" p-4">
              <beneficiary-list-table-edit
                                           [dropdowns]="parentWorkflow.workflowDropdowns"
                                           [itemList]="cardData.beneficiaryList" [editIndex]="i"
                                           (listChanged)="onBeneficiaryChanged($event)"
                                           [isServiceOrFunerary]="isServiceOrFunerary"></beneficiary-list-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
  <input hidden [class.ng-invalid]="cardData?.beneficiaryList?.length < 1" />
  <validation-message *ngIf="cardData?.beneficiaryList?.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>
</main>
